import { getFirestore, doc, updateDoc, deleteDoc } from "firebase/firestore";
import { app } from "../config";

const db = getFirestore(app);

/**
 * Soft-delete an event (moves to Deleted tab, restorable)
 */
export const softDeleteEvent = async (eventId) => {
  try {
    await updateDoc(doc(db, "events", eventId), {
      status: "deleted",
      deletedAt: new Date(),
    });
    return { success: true };
  } catch (error) {
    console.error("Error soft-deleting event:", error);
    return { success: false, error: error.message };
  }
};

/**
 * Cancel an event (stays visible with Cancelled status; vendors start at 0)
 */
export const cancelEvent = async (eventId) => {
  try {
    await updateDoc(doc(db, "events", eventId), {
      status: "cancelled",
      cancelledAt: new Date(),
    });
    return { success: true };
  } catch (error) {
    console.error("Error cancelling event:", error);
    return { success: false, error: error.message };
  }
};

/**
 * Restore a soft-deleted event back to published
 */
export const restoreEvent = async (eventId) => {
  try {
    await updateDoc(doc(db, "events", eventId), {
      status: "published",
      deletedAt: null,
    });
    return { success: true };
  } catch (error) {
    console.error("Error restoring event:", error);
    return { success: false, error: error.message };
  }
};

/**
 * Permanently delete an event — cannot be undone
 */
export const permanentlyDeleteEvent = async (eventId) => {
  try {
    await deleteDoc(doc(db, "events", eventId));
    return { success: true };
  } catch (error) {
    console.error("Error permanently deleting event:", error);
    return { success: false, error: error.message };
  }
};
